
import httpClient from '../httpClient'
import authHeader from './AuthHeader'

class InvoiceDataService {
  getAll () {
    return httpClient.get('/invoices', { headers: authHeader() })
  }
  create (data) {
    return httpClient.post('/invoices', data, { headers: authHeader() })
  }
}

export default new InvoiceDataService()
